import React from "react";
import "./CourseRegisterationStyle.css";
import Checkbox from "../../../components/globalComponents/checkboxes/Checkbox";
import PrimaryButtonImg from "../../../components/globalComponents/buttons/primaryButtonImg/PrimaryButtonImg";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import {
  lmsSliceData,
  getAllElectiveCourse,
  getAllElectiveSession,getCourseByStudentId
} from "../../../reducers/lmsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import PageLoader from "../../../components/globalComponents/PageLoader/PageLoader";
import { useState } from "react";

const localizer = momentLocalizer(moment);

const CourseRegisteration = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isFetching, getElectiveCourse, getElectiveSession,getStudentCourseData } =
    useSelector(lmsSliceData);
  const [category, setCategory] = useState([]);
  const [confirm, setConfirm] = useState(false);

  useEffect(() => {
    dispatch(getAllElectiveCourse());
    dispatch(getCourseByStudentId())
  }, []);

  useEffect(() => {
    // if (check) {
    let obj = {
      courseIdArray: category,
    };
    if (confirm) {
      dispatch(getAllElectiveSession(obj));
      setConfirm(false);
    }
    // eslint-disable-next-line
  }, [category]);

  const categoryHandleChange = (e) => {
    const { value } = e.target;
    if (category.includes(value)) {
      const i = category.indexOf(value);
      let arr = category;
      arr.splice(i, 1);
      setCategory([...arr]);
    } else {
      setCategory((prev) => [...prev, value]);
    }
    setConfirm(true);
  };

  // Calander Data
  let eventList = [];
  getElectiveSession?.length > 0 &&
    getElectiveSession?.forEach((ele) => {
      ele?.CourseSessions.forEach((data) => {
        let y = parseInt(moment(data?.date).format("YYYY")); // Year
        let m = parseInt(moment(data?.date).format("MM") - 1); // Month
        let d = parseInt(moment(data?.date).format("DD")); // date
        let sh = parseInt(data?.fromTime.substr(0, 2)); //start hours
        let sm = parseInt(data?.fromTime.substr(3));
        let eh = parseInt(data?.toTime.substr(0, 2));
        let em = parseInt(data?.fromTime.substr(3));
        let obj = {
          title: data.name,
          start: new Date(y, m, d, sh, sm),
          end: new Date(y, m, d, eh, em),
        };
        // console.log(new Date(y, m, d, sh, sm), "objjj")
        eventList?.push(obj);
      });
    });
    getStudentCourseData?.length > 0 &&
      getStudentCourseData?.forEach((ele) => {
        ele?.CourseRoster?.CourseSessions.forEach((data) => {
          let y = parseInt(moment(data?.date).format("YYYY")); // Year
          let m = parseInt(moment(data?.date).format("MM") - 1); // Month
          let d = parseInt(moment(data?.date).format("DD")); // date
          let sh = parseInt(data?.fromTime.substr(0, 2)); //start hours
          let sm = parseInt(data?.fromTime.substr(3));
          let eh = parseInt(data?.toTime.substr(0, 2));
          let em = parseInt(data?.fromTime.substr(3));
          let obj = {
            title: data.name,
            start: new Date(y, m, d, sh, sm),
            end: new Date(y, m, d, eh, em),
          };
          // console.log(new Date(y, m, d, sh, sm), "objjj")
          eventList?.push(obj);
        });
      });

  useEffect(() => {
    if (getElectiveCourse?.length > 0 && category.length === 0) {
      const data = getElectiveCourse?.map((res) => res.id);
      setCategory(data);
      let obj = {
        courseIdArray: data,
      };
      dispatch(getAllElectiveSession(obj));
    }
    // eslint-disable-next-line
  }, [getElectiveCourse]);

  return (
    <>
      {isFetching && <PageLoader />}
      <div className="pageHeader">
        <p className="componentHeading"></p>
        <div className="pageTogglers">
          <div className="pageToggler active">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.99999 18.6667C9.83332 18.6667 9.74999 18.6667 9.58332 18.5834C9.33332 18.5 9.16666 18.3334 8.99999 18L7.74999 16.4167C7.49999 16.0834 7.41666 15.9167 7.33332 15.8334C7.24999 15.75 7.08332 15.6667 6.91666 15.5834C6.83332 15.5834 6.58332 15.5834 6.24999 15.5834C4.99999 15.5834 4.41666 15.5834 3.83332 15.3334C3.08332 15 2.49999 14.4167 2.16666 13.6667C1.91666 13.0834 1.91666 12.5 1.91666 11.25V6.50004C1.91666 5.00004 1.91666 4.25004 2.24999 3.58337C2.49999 3.00004 2.99999 2.50004 3.58332 2.25004C4.24999 1.83337 4.99999 1.83337 6.49999 1.83337H13.5C15 1.83337 15.75 1.83337 16.4167 2.16671C17 2.50004 17.5 3.00004 17.75 3.58337C18.0833 4.25004 18.0833 5.00004 18.0833 6.50004V11.25C18.0833 12.5 18.0833 13.0834 17.8333 13.6667C17.5 14.4167 16.9167 15 16.1667 15.3334C15.5833 15.5834 15 15.5834 13.75 15.5834C13.4167 15.5834 13.25 15.5834 13.0833 15.5834C12.9167 15.5834 12.75 15.6667 12.6667 15.8334C12.5833 15.9167 12.5 16.0834 12.25 16.3334L11 18C10.75 18.3334 10.5833 18.5 10.3333 18.5834C10.25 18.6667 10.1667 18.6667 9.99999 18.6667ZM6.49999 3.16671C5.16666 3.16671 4.58332 3.16671 4.16666 3.33337C3.83332 3.50004 3.49999 3.83337 3.33332 4.16671C3.16666 4.58337 3.16666 5.16671 3.16666 6.50004V11.25C3.16666 12.3334 3.16666 12.8334 3.33332 13.25C3.49999 13.75 3.91666 14.0834 4.33332 14.25C4.66666 14.4167 5.24999 14.4167 6.33332 14.4167C6.74999 14.4167 6.99999 14.4167 7.24999 14.5C7.58332 14.5834 7.91666 14.75 8.16666 15C8.33332 15.1667 8.49999 15.3334 8.74999 15.6667L9.99999 17.3334C9.99999 17.3334 9.99999 17.3334 9.99999 17.4167C9.99999 17.4167 9.99999 17.4167 9.99999 17.3334L11.25 15.75C11.5 15.4167 11.6667 15.1667 11.8333 15C12.0833 14.75 12.4167 14.5834 12.75 14.5C13 14.4167 13.25 14.4167 13.6667 14.4167C14.75 14.4167 15.25 14.4167 15.6667 14.25C16.0833 14.0834 16.5 13.6667 16.6667 13.25C16.8333 12.9167 16.8333 12.3334 16.8333 11.25V6.50004C16.8333 5.16671 16.8333 4.58337 16.6667 4.16671C16.5 3.83337 16.1667 3.50004 15.8333 3.33337C15.4167 3.16671 14.75 3.16671 13.5 3.16671H6.49999Z"
                fill="#0061BF"
              />
              <path
                d="M10 12.4167C9.83333 12.4167 9.75 12.4167 9.58333 12.3334C9.25 12.25 9.08333 12.0834 8.75 11.75C7.66666 10.8334 6.91666 10.0834 6.58333 9.66671C5.75 8.58337 5.91666 7.00004 7 6.08337C7.83333 5.41671 9.08333 5.41671 10 6.08337C10.9167 5.41671 12.0833 5.41671 13 6.16671C14.0833 7.08337 14.25 8.58337 13.4167 9.75004C13 10.25 12 11.1667 11.25 11.8334C10.9167 12.0834 10.75 12.3334 10.4167 12.4167C10.25 12.4167 10.1667 12.4167 10 12.4167ZM8.5 6.91671C8.25 6.91671 8 7.00004 7.75 7.16671C7.25 7.58337 7.16666 8.41671 7.58333 8.91671C7.83333 9.33337 8.58333 10 9.58333 10.8334C9.75 11 9.91666 11.1667 10 11.1667H10.0833C10.1667 11.1667 10.3333 11 10.5 10.8334C11.5 9.91671 12.1667 9.25004 12.5 8.91671C12.9167 8.33337 12.8333 7.58337 12.3333 7.08337C11.5833 6.66671 10.8333 6.91671 10.5 7.33337C10.3333 7.50004 10.1667 7.58337 10 7.58337C9.83333 7.58337 9.66666 7.50004 9.5 7.33337C9.25 7.08337 8.91666 6.91671 8.5 6.91671Z"
                fill="#0061BF"
              />
            </svg>
            Course Registration
          </div>
        </div>
        <div></div>
      </div>
      <div className="filterBar">
        <div className="searchBox">
          <img src="../assets/icons/search-sm.svg" alt="" />
          <input type="text" className="searchInput" placeholder="Search ..." />
        </div>
        <button
          className="fiterBtn"
          //  onClick={() => setOpenFilters(!openFilters)}
        >
          {" "}
          <img src="../assets/icons/filter-lines.svg" alt="" /> Filters
        </button>
      </div>
      <div className="courseRegistrationContainer">
        <div className="courseTableContainer">
          <div className="courseRegisterationTableOuter">
            <table
              cellPadding={0}
              cellSpacing={0}
              className="courseRegistrationTable"
            >
              <thead>
                <tr>
                  <th>{/* <Checkbox /> */}</th>
                  <th>Course</th>
                  <th>Course Code</th>
                  <th>Type</th>
                  <th>Status</th>
                  {/* <th>Cohort</th>
                  <th>Status</th> */}
                </tr>
              </thead>
              <tbody>
                {getElectiveCourse?.length > 0 &&
                  getElectiveCourse?.map((res, i) => (
                    <tr>
                      <td>
                        <div className="checkmarkContainerOuter">
                          <label class="checkboxContainer">
                            {/* <input type="checkbox" ckecked="cheked" /> */}
                            <input
                              type="checkbox"
                              name="category"
                              id={i}
                              value={res?.id}
                              onChange={categoryHandleChange}
                              // checked={category[] === res.CourseRoster.id}
                              checked={
                                category.includes(res?.id) ? true : false
                              }
                            />
                            <span class="checkmark"></span>
                          </label>
                        </div>
                      </td>
                      <td>{res?.courseName}</td>
                      <td>{res?.courseCode}</td>
                      <td>{res?.courseType}</td>
                      <td>
                        {/* <div className="primaryTag">Available</div>
                                                <div className="dangerTag">Clashing</div> */}
                        {res?.isCourseBidSelected ? (
                          <div className="greyTag">Selected</div>
                        ) : (
                          <div className="greyTag">Not Selected</div>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <div className="fixedRowBottom">
            {/* <p>Total is less than 100</p> */}
            <p></p>
            <PrimaryButtonImg
              img={"/assets/icons/whiteArrow.svg"}
              children={"Select Preference"}
              classname={"successBtn"}
            />
          </div>
        </div>
        {/* <div className="courseTimeTableOuter"> */}
        <Calendar
          localizer={localizer}
          events={eventList}
          startAccessor="start"
          endAccessor="end"
        />
        {/* </div> */}
      </div>
    </>
  );
};

export default CourseRegisteration;
